import { render, staticRenderFns } from "./ModalVehicleCategoryEdit.vue?vue&type=template&id=491e3342&"
import script from "./ModalVehicleCategoryEdit.vue?vue&type=script&lang=js&"
export * from "./ModalVehicleCategoryEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports